import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BEResponse } from '@qtek/core/api-core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import {
  DocumentTemplate,
  HTTP_BASE_URL,
  ITemplateData,
  TemplateVersionStage,
} from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { HttpEntityManager } from '../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class TemplateDataService extends HttpEntityManager<
  DocumentTemplate,
  DocumentTemplate
> {
  protected http = inject(HttpClient);
  private webSocketService = inject(WebSocketService);
  private httpBaseUrl = inject(HTTP_BASE_URL);

  entityName: WebsocketEntTypes = 'TemplateData';
  wsManager = new WSEntityManager(this.webSocketService, this.entityName);

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  constructor() {
    super();
  }

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...payload }, true);
  }

  getTemplateData(
    id: string,
    version: string
  ): Observable<BEResponse<ITemplateData>> {
    return this.http.get<BEResponse<ITemplateData>>(
      `${this.httpBaseUrl}/api/v2/model/${this.entityName}/${id}/${version}`,
      { withCredentials: true }
    );
  }

  createTemplateData(
    tplId: string,
    baseDocId?: string,
    body?: unknown
  ): Observable<BEResponse<ITemplateData>> {
    return this.http.post<BEResponse<ITemplateData>>(
      `${this.httpBaseUrl}/api/v2/model/${this.entityName}`,
      {
        template: tplId,
        body: body ?? {},
        ...(baseDocId ? { baseDocId } : {}),
      },
      { withCredentials: true }
    );
  }

  updateTemplateData(
    id: string,
    version: string,
    body: unknown,
    versionStage: TemplateVersionStage
  ): Observable<BEResponse<ITemplateData>> {
    return this.http.put<BEResponse<ITemplateData>>(
      `${this.httpBaseUrl}/api/v2/model/${this.entityName}/${id}/${version}`,
      { body, versionStage },
      { withCredentials: true }
    );
  }

  deleteTemplate(templateId: string): void {
    this.wsManager.delete({ id: templateId });
  }
}
